import { render, staticRenderFns } from "./choose-properties.vue?vue&type=template&id=244b9f9c&"
import script from "./choose-properties.vue?vue&type=script&lang=js&"
export * from "./choose-properties.vue?vue&type=script&lang=js&"
import style0 from "./choose-properties.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports